<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Course Report</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="center" class="row-header">
            <h2>Range Selection</h2>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Academic year</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Semester</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Category</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center">
            <div class="button button-icon button-green">
              Export Report
              <img src="@/assets/images/admin/Download.svg" class="icon icon-invert" />
            </div>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "courseReport"
};
</script>
